import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { VerticalMenuComponent } from './components/vertical-menu/vertical-menu.component';
import { DashboardFacade } from './facades/dashboard.facade';
import { SharedModule } from '@app/shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';


@NgModule({
  declarations: [
    DashboardComponent,
    VerticalMenuComponent
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    TranslateModule
  ],
  providers: [DashboardFacade]
})
export class DashboardModule { }
